import React, { useState, useEffect } from 'react';
import { cognitoService } from '../../services/cognitoService';
import { Link } from 'react-router-dom';
import AuthLayout from '../layout/AuthLayout';

const Signup = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [confirmationCode, setConfirmationCode] = useState('');
  const [isConfirming, setIsConfirming] = useState(false);
  const [error, setError] = useState('');
  const [passwordErrors, setPasswordErrors] = useState([]);

  const validatePassword = (pass) => {
    const errors = [];
    if (pass.length < 8) errors.push("Password must be at least 8 characters long");
    if (!/[A-Z]/.test(pass)) errors.push("Password must contain at least one uppercase letter");
    if (!/[a-z]/.test(pass)) errors.push("Password must contain at least one lowercase letter");
    if (!/[0-9]/.test(pass)) errors.push("Password must contain at least one number");
    if (!/[^A-Za-z0-9]/.test(pass)) errors.push("Password must contain at least one special character");
    return errors;
  };

  useEffect(() => {
    setPasswordErrors(validatePassword(password));
  }, [password]);

  const handleSignup = async (e) => {
    e.preventDefault();
    setError('');
    if (passwordErrors.length > 0) {
      setError('Please fix the password errors before submitting.');
      return;
    }
    try {
      await cognitoService.signUp(username, password, email);
      setIsConfirming(true);
    } catch (error) {
      setError('Failed to sign up. ' + error.message);
    }
  };

  const handleConfirmation = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await cognitoService.confirmSignUp(username, confirmationCode);
      // Handle successful confirmation (e.g., redirect to login)
    } catch (error) {
      setError('Failed to confirm signup. ' + error.message);
    }
  };

  return (
    <AuthLayout>
      <div>
        <h2 className="text-center text-3xl font-extrabold text-gray-900">
          {isConfirming ? 'Confirm your account' : 'Create your account'}
        </h2>
      </div>
      {isConfirming ? (
        <form className="mt-6 space-y-4" onSubmit={handleConfirmation}>
          <div>
            <label htmlFor="confirmation-code" className="sr-only">Confirmation Code</label>
            <input
              id="confirmation-code"
              name="confirmation-code"
              type="text"
              required
              className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
              placeholder="Confirmation Code"
              value={confirmationCode}
              onChange={(e) => setConfirmationCode(e.target.value)}
            />
          </div>
          <button type="submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            Confirm Signup
          </button>
        </form>
      ) : (
        <form className="mt-6 space-y-4" onSubmit={handleSignup}>
          <div>
            <label htmlFor="username" className="sr-only">Username</label>
            <input
              id="username"
              name="username"
              type="text"
              required
              className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div>
            <label htmlFor="email" className="sr-only">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              required
              className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label htmlFor="password" className="sr-only">Password</label>
            <input
              id="password"
              name="password"
              type="password"
              required
              className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          {passwordErrors.length > 0 && (
            <div className="rounded-md bg-yellow-50 p-4 max-h-40 overflow-y-auto">
              <div className="flex">
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-yellow-800">Password requirements:</h3>
                  <ul className="mt-2 text-sm text-yellow-700 list-disc list-inside">
                    {passwordErrors.map((error, index) => (
                      <li key={index}>{error}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          )}
          <button
            type="submit"
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            disabled={passwordErrors.length > 0}
          >
            Sign Up
          </button>
        </form>
      )}
      {error && <p className="mt-2 text-center text-sm text-red-600">{error}</p>}
      <div className="mt-4 text-sm text-center">
        <Link to="/auth/login" className="font-medium text-indigo-600 hover:text-indigo-500">
          Already have an account? Sign in
        </Link>
      </div>
    </AuthLayout>
  );
};

export default Signup;